export default "__VITE_ASSET__DHUPCwcR__"